module.exports = __webpack_public_path__ + "html/info.template.html";